import PaymentReceivedModal from './PaymentReceivedModal'

const PaymentReceivedTrialEnded = () => <PaymentReceivedModal bodyText="We'll notify you via email when the transaction is complete." />

export default PaymentReceivedTrialEnded
